<template>
  <section>
    <h1 class="title is-1">
      David Mouat Thomson
      <br/>
      <span class="subtitle is-4">Passionate about Software Architecture, AI Driven Development, and Software Engineering</span>
    </h1>

  </section>
</template>

<script>

  export default {
    name: "Title",
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>